/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-27 22:22:33
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 16:51:52
 */
const teamManage = [
	{
		path: '/teamManage',
		component: null,
		name: '团队',
		redirect: '/teamManage/achievements',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: true,
		visible: true,
		useTemplate: true,
		children: [
			{
				path: 'achievements',
				component: 'teamManage/performanceManage',
				name: '业绩管理',
				parentId: 2,
				showBread: true,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'subAccount',
				component: 'teamManage/accountManage/index',
				name: '子账号管理',
				parentId: 2,
				showBread: true,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'groupConf',
				component: 'teamManage/groupConf',
				name: '团队资料',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: true,
				children: null,
			},
			{
				path: 'roleManage',
				component: 'teamManage/roleManage',
				name: '角色管理',
				parentId: 2,
				showBread: true,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'department',
				component: 'teamManage/department',
				name: '部门管理',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: true,
				children: null,
			},
			{
				path: 'delegationhead',
				component: 'teamManage/delegationHead',
				name: '团长授权',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			}
		],
	},
];

export default teamManage;
